var _style, _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "153px",
    x: "0px",
    y: "0px",
    viewBox: "400 200 800 1600",
    style: {
      enableBackground: "new 0 0 1600 1600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000058578485388212522910000001994383712936405136_);}\n\t.st3{fill:url(#SVGID_00000093173925758283924070000007734567393302012593_);}\n\t.st4{fill:url(#SVGID_00000029745306160400516370000013622285786788629173_);}\n\t.st5{opacity:0.25;fill:#1B1464;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1600,
    height: 1200
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.3944,
    y1: 419.4329,
    x2: 990.5912,
    y2: 593.5969
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2600F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42C1F0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M977.1,672.8c0-40.1-21.5-74.2-51.2-85.9c-7.2-2.9-14.8-4.4-22.8-4.4c-1.4,0-2.9,0-4.3,0.1l-2.1,0.2 l-10.3,0.8l-0.5,0l-40.4,2.8l-57.1,4l-197.6,10.2c-0.9,0-1.8,0-2.7,0V600c0-111.1,90.1-201.2,201.2-201.2 c63.7,0,120.6,29.7,157.4,75.9C946.8,474.7,1021.6,556.4,977.1,672.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182519180033941571020000005051624217354085561_",
    gradientUnits: "userSpaceOnUse",
    x1: 997.4073,
    y1: 779.938,
    x2: 911.096,
    y2: 380.7492
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2600F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42C1F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182519180033941571020000005051624217354085561_)"
    },
    d: "M1109.3,638.7 c0,61.2-35.2,118.6-89.8,146.3c-24,12.2-47.7,16.2-74.2,16.2c-23.2,0-44.9-8.3-63-22.7c-13.2-10.4-24.5-24-33.3-39.8 c-3-5.4-5.7-11.2-8.1-17.1c-6-15-9.9-31.4-11.3-48.8h147.5c0,0,0,0,0,0c44.6-116.3-30.2-198-30.2-198c10.3,0.1,20.4,1.1,30.2,3.1 C1052.4,492.6,1109.3,559,1109.3,638.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021842108395756840750000017789723045055266183_",
    gradientUnits: "userSpaceOnUse",
    x1: 811.2595,
    y1: 592.5782,
    x2: 968.469,
    y2: 679.9169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42C1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021842108395756840750000017789723045055266183_)"
    },
    d: "M977.1,672.8H829.6 c-0.1-1.9-0.3-3.8-0.3-5.7c0,0,0,0,0-0.1c2.3-43.7,30.1-79,65.4-83.9c0.7-0.1,1.4-0.2,2.1-0.3l2.1-0.2c1.4-0.1,2.8-0.1,4.3-0.1 c8,0,15.6,1.5,22.8,4.4C955.6,598.6,977.1,632.6,977.1,672.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077289828434740861100000016456286203407264441_",
    gradientUnits: "userSpaceOnUse",
    x1: 777.8925,
    y1: 591.6414,
    x2: 679.2515,
    y2: 838.244
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42C1F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077289828434740861100000016456286203407264441_)"
    },
    d: "M945.3,801.2H590.9 c-55.4,0-100.3-44.9-100.3-100.2c0-36.2,19.2-67.9,48-85.6c7.3-4.5,15.3-8.1,23.7-10.6c8.2-2.4,16.9-3.8,25.8-4.1 c0.9,0,1.8,0,2.7,0l197.6-10.2l57.1-4l40.4-2.8l0.5,0l10.3-0.8c-0.7,0.1-1.4,0.2-2.1,0.3c-35.4,4.9-63.2,40.1-65.4,83.9 c0,0,0,0,0,0.1c0.1,1.9,0.2,3.8,0.3,5.7c1.3,17.4,5.2,33.8,11.3,48.8c2.4,6,5.1,11.7,8.1,17.1c8.8,15.9,20.1,29.4,33.3,39.8 C900.4,792.9,922.1,801.2,945.3,801.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M898.8,582.6c0,0-57.4,17.9-57.4,89.4l-1.4,0.7h-10.5c-0.1-1.9-0.3-3.8-0.3-5.7c0,0,0,0,0-0.1 c2.3-43.7,30.1-79,65.4-83.9c0.7-0.1,1.4-0.2,2.1-0.3L898.8,582.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.25fd3cfbf07d7ccffea5c1a13bfaa5a2.svg";
export { ForwardRef as ReactComponent };